export default __webpack_public_path__ + "1a35f9252a667015f3526cd62d71f342.png";